export function TinyBox({
  children,
  title,
  actionComponent,
}: {
  children: React.ReactNode
  title?: string
  actionComponent?: React.ReactNode
}) {
  return (
    <div className="bg-white relative rounded-lg border-[1.5px] border-gray-300 px-4 py-2 h-fit flex flex-row w-full justify-between">
      <div className="flex flex-col gap-1">
        {title && <h3 className="">{title}</h3>}
        {children}
      </div>
      {actionComponent && actionComponent}
    </div>
  )
}
